import { render, staticRenderFns } from "./DialogRadioButtons.vue?vue&type=template&id=313ebf88&scoped=true&"
import script from "./DialogRadioButtons.vue?vue&type=script&lang=js&"
export * from "./DialogRadioButtons.vue?vue&type=script&lang=js&"
import style0 from "./DialogRadioButtons.vue?vue&type=style&index=0&id=313ebf88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313ebf88",
  null
  
)

export default component.exports